import React, { useState } from "react";
import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { createFastCash, createFastCashEntry } from "./httpCalls";
import { v4 as uuidv4 } from "uuid";
import { fastCashAdded, fastCashAmount } from "./fastCashSlice";
import moment from "moment";
import { toast } from "react-toastify";

function AddCash({ onClose }) {
  const companyCode = localStorage.getItem("companyCode");
  const dispatch = useDispatch();
  const fastCashes = useSelector((state) => state.fastCash.fastCashes);
  const [state, setState] = useState({
    createFastCash: false,
    loading: false,
    name: "",
    amount: 0,
    comment: "",
    date: "",
    selectedFastCash: "",
  });

  const handleChange = (e) => {
    let name = e.target.name;
    let value;
    if (name == "fastCash" || name == "createFastCash") {
      value = e.target.checked;
    } else {
      value = e.target.value;
    }
    setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async () => {
    if (state.selectedFastCash == "" && state.name == "") {
      toast.configure();
      toast.info("Select Fast Cash or Enter Name");
      return;
    }
    let _id = uuidv4();
    let id = _id.replaceAll("-", "");
    let date = moment(Date.now()).format("DD-MM-YYYY");
    onClose();
    if (state.createFastCash) {
      const user = {
        _id: id,
        date: date,
        name: state.name,
        totalAmount: state.amount,
        companyCode: companyCode,
      };
      dispatch(fastCashAdded({ index: 0, user: user }));
      let res = await createFastCash(
        companyCode,
        state.name,
        date,
        id,
        dispatch
      );
      if (res == "success") {
        createFastCashEntry(
          companyCode,
          state.name,
          state.comment,
          state.amount,
          date,
          id,
          dispatch
        );
      }
    } else {
      const { amount, selectedFastCash } = state;
      dispatch(fastCashAmount({ _id: selectedFastCash, amount: amount }));
      createFastCashEntry(
        companyCode,
        state.name,
        state.comment,
        state.amount,
        date,
        id,
        dispatch
      );
    }
  };
  return (
    <Stack spacing={2}>
      <Typography variant="h5" sx={{ color: "#4EAF51" }}>
        Add Fast Cash
      </Typography>
      <Stack alignItems="flex-end">
        <FormControlLabel
          control={
            <Checkbox
              checked={state.createFastCash}
              name="createFastCash"
              onChange={handleChange}
            />
          }
          label="Create New"
        />
      </Stack>
      {state.createFastCash == false && (
        <FormControl style={{ width: "100%" }} size="small">
          <InputLabel>Select Fast Cash</InputLabel>
          <Select
            label="Select Fast Cash"
            style={{ background: "#F2F2F2" }}
            name="selectedFastCash"
            enforcefocus={false}
            onChange={handleChange}
          >
            {fastCashes &&
              fastCashes.map((cash) => {
                return <MenuItem value={cash._id}>{cash.name}</MenuItem>;
              })}
          </Select>
        </FormControl>
      )}
      {state.createFastCash == true && (
        <TextField
          size="small"
          autoFocus
          fullWidth
          name="name"
          label="Name"
          value={state.name}
          onChange={handleChange}
          variant="outlined"
        />
      )}
      <TextField
        size="small"
        fullWidth
        label="Comment"
        name="comment"
        value={state.comment}
        onChange={handleChange}
        variant="outlined"
      />
      <TextField
        size="small"
        fullWidth
        name="amount"
        label="Amount"
        value={state.amount}
        onChange={handleChange}
        variant="outlined"
      />

      <Stack direction="row" justifyContent="space-evenly">
        <Button variant="contained" onClick={handleSubmit}>
          Submit
        </Button>
        <Button variant="outlined" onClick={onClose}>
          Cancel
        </Button>
      </Stack>
    </Stack>
  );
}

export default AddCash;
